import { Navigate, Outlet, useLocation } from 'react-router-dom';
import DarkLoadingSpinner from '../components/LoadingSpinner/DarkLoadingSpinner';
import { useAuth } from '../contexts/AuthContext';
import { ROUTE_PATHS } from './routePaths';

/**
 * IntermediateAuthRoute - For pages that require partial authentication but not full authentication
 *
 * This route is used for the TermsAndConditions page which sits between:
 * - Login + OTP (isPartiallyAuthenticated = true)
 * - Full authentication (isAuthenticated = true after accepting terms)
 *
 * It checks isPartiallyAuthenticated from AuthContext.
 */
const IntermediateAuthRoute = () => {
  const location = useLocation();
  const { isPartiallyAuthenticated, isAuthenticated, loading } = useAuth();

  // to /login caused by isPartiallyAuthenticated being false momentarily.
  if (loading) {
    return <DarkLoadingSpinner />;
  }

  if (isAuthenticated) return <Outlet />;

  if (!isPartiallyAuthenticated) {
    if (!localStorage.getItem('pendingRedirectUrl')) {
      localStorage.setItem('pendingRedirectUrl', location.pathname + location.search);
    }
    return <Navigate to={ROUTE_PATHS.LOGIN} replace />;
  }

  return <Outlet />;
};

export default IntermediateAuthRoute;
